export default {
  data() {
    return {
      tbMacroses: [
        {
          name: "site",
          value: "{site}",
        },
        {
          name: "land",
          value: "{land}",
        },
        {
          name: "tid",
          value: "{tid}",
        },
        {
          name: "p1",
          value: "{p1}",
        },
        {
          name: "p2",
          value: "{p2}",
        },
        {
          name: "p3",
          value: "{p3}",
        },
        {
          name: "p4",
          value: "{p4}",
        }
      ],
      macroses: [
        {
          name: "site",
          value: "{site}",
        },
        {
          name: "money",
          value: "{money}",
        },
        {
          name: "status",
          value: "{status}",
        },
        {
          name: "land",
          value: "{land}",
        },
        {
          name: "tid",
          value: "{tid}",
        },
        {
          name: "cpl_price",
          value: "{cpl_price}",
        },
        {
          name: "p1",
          value: "{p1}",
        },
        {
          name: "p2",
          value: "{p2}",
        },
        {
          name: "p3",
          value: "{p3}",
        },
        {
          name: "p4",
          value: "{p4}",
        },
        {
          name: "rstype",
          value: "{rstype}",
        }
      ],
    };
  },
  methods: {
    addMacros(macros, title) {
      let queryCheck1 = `&${macros.name}=${macros.value}`;
      let queryCheck2 = `?${macros.name}=${macros.value}`;

      if (this.platform[title].includes(`&${macros.name}`)) {
        this.platform[title] = this.platform[title].replace(queryCheck1, "");
      } else if (this.platform[title].includes(`?${macros.name}`)) {
        this.platform[title] = this.platform[title].replace(queryCheck2, "");
        if (!this.platform[title].includes("?")) {
          this.platform[title] = this.platform[title].replace("&", `?`);
        }
      } else if (this.platform[title].includes("?")) {
        this.platform[title] += queryCheck1;
      } else {
        this.platform[title] += queryCheck2;
      }
    },
  },
};
